import { useMutation } from "react-query";
import { createAdditionalDiagnosis } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

const useCreateAdditionalDiagnosis = (options: Record<string, any> = {}) => {
  const { onSuccess = () => {}, onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: Record<string, any> }) =>
      createAdditionalDiagnosis(clientId, payload),
    {
      onSuccess: (response, variables) => {
        showToast({ message: "Additional diagnosis added successfully." });
        onSuccess(response, variables);
      },
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.error || "Failed to add additional diagnosis";
        showToast({ message: errorMessage, errorState: true });
        onError(error);
      },
      ...otherOptions,
    }
  );

  return {
    createAdditionalDiagnosisMutation: mutate,
    isCreateAdditionalDiagnosisLoading: isLoading,
    ...rest,
  };
};

export default useCreateAdditionalDiagnosis;
